// GENERATED FILE - DO NOT MODIFY

export enum HappeningStatusDto {
    Ongoing = "Ongoing",
    Upcoming = "Upcoming",
    Past = "Past",
}